const CalendarComponent = {
    templateUrl: '/formViewer/component/calendar/calendar.tpl.html',
    controller: 'calendarController',
    bindings: {
        fieldStructure: '<',
        timeLastModified: '<',
        hideLabel: '<'
    }
};

angular.module('umFormViewer')
    .component('uiCalendar', CalendarComponent);
